const ActionTypes = {
  SHOW_ERROR: 'SHOW_ERROR',
};

module.exports = {
  ActionTypes,
};
